import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UserCreatePayload } from '../models/user-create-model';
import { ServiceCreatePayload } from '../models/service-create-model';
import { ServiceCreateResponse } from '../models/service-create-response-model';

@Injectable({
  providedIn: 'root',
})
export class PromoSMSService {
  constructor(private http: HttpClient) {}

  lFN_GetPromoSMSServiceList() {
    return this.http.get(`${environment.ROOT_URL}/promo-sms-log`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SavePromoSMSService(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(
      `${environment.ROOT_URL}/promo-sms-log`,
      payload,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  lFN_GetPromoSMSById(promoSmsLogId: number) {
    return this.http.get(`${environment.ROOT_URL}/promo-sms-log/promo-sms-log-id/${ promoSmsLogId }`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_TogglePromoServiceStatus(promoSmsLogId: number) {
    return this.http.patch(`${environment.ROOT_URL}/promo-sms-log/status/${ promoSmsLogId }`, {},
      { observe: 'response', responseType: 'json' }
    );
  }

}
